import { getDataRoomFile } from "@vega-api/generated/coinvest-deal-data-room-files-gp/coinvest-deal-data-room-files-gp";
import { getDataRoomResourceFileForLp } from "@vega-api/generated/coinvest-deal-data-room-files-lp/coinvest-deal-data-room-files-lp";
import { downloadUrlAsFile } from "@vega-core/utils/download.helpers";

type GpDataRoomFileParams = {
  role: "gp";
  dealId: string;
  dataRoomId: string;
  fileId: string;
  filename: string;
};

type LpDataRoomFileParams = {
  role: "lp";
  dealOpportunityId: string;
  dataRoomId: string;
  resourceId: string;
  filename: string;
};

type DataRoomFileParams = GpDataRoomFileParams | LpDataRoomFileParams;

async function fetchDataRoomFileUrl(
  params: DataRoomFileParams,
): Promise<string | undefined> {
  if (params.role === "gp") {
    const response = await getDataRoomFile(
      params.dealId,
      params.dataRoomId,
      params.fileId,
      { withDownloadUrl: true },
    );

    return response.data.file.url;
  }

  const response = await getDataRoomResourceFileForLp(
    params.dealOpportunityId,
    params.dataRoomId,
    params.resourceId,
    { withDownloadUrl: true },
  );

  return response.data.file.url;
}

export async function openDataRoomFile(
  params: DataRoomFileParams,
): Promise<void> {
  const url = await fetchDataRoomFileUrl(params);

  if (!url) return;

  await downloadUrlAsFile(url, params.filename);
}
